"use client";
import { init, onMetrixUserIdReceived, subscribePush } from "@metrixorg/websdk";
import { isChannel } from "@website/utils/channel/helpers";
import { useEffect } from "react";

export const Metrix = () => {
  if (!isChannel(["android"])) return null;

  useEffect(() => {
    init("ackcrxjytpuhtry", "c78c8d9e-7115-47f1-870d-09fd3f9c1329", {
      sessionTracking: {
        enabled: true,
        packageName: "com.pintapin.pintapin"
      },
      onSiteMessaging: {
        enabled: true
      },
      push: {
        enabled: true,
        publicKey:
          "BM_h1-9yFK-qAfb_89Pn4T2mDstUiYThjrOid2PhGCXobs9CKVQ1hgYTXg4Up59pZUhMltBQPIZFYvgkzvi61F0",
        hasSW: true
      }
    });
    onMetrixUserIdReceived().then(() => {
      subscribePush();
    });
  }, []);

  return null;
};
